import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { WeekCalendar } from 'src/app/models/diagnostic/WeekCalendar';
import { WeekGridComponent } from './week-grid/week-grid.component';

@Component({
  selector: 'app-weekly-selector',
  templateUrl: './weekly-selector.component.html',
  styleUrls: ['./weekly-selector.component.css'],
})
export class WeeklySelectorComponent {
  // Matches BE WeekCalendar.DEFAULT_TIMEZONE: not user-selectable for now
  @Input() timezone: string = 'Europe/Rome';
  @Input() set value(calendar: WeekCalendar | null | undefined) {
    this.savedValue = calendar;
    this.resetDraft();
  }
  @Output() valueChange = new EventEmitter<WeekCalendar>();
  // false = read-only view: no painting, no Save
  @Input() editMode: boolean = true;

  get popupVisible(): boolean {
    return this._popupVisible;
  }

  @Input() set popupVisible(value: boolean) {
    if (this._popupVisible === value) return;
    // Reopening discards whatever was left unsaved by a previous cancel
    if (value) this.resetDraft();
    this._popupVisible = value;
    this.popupVisibleChange.emit(value);
  }

  @Output() popupVisibleChange = new EventEmitter<boolean>();

  @ViewChild(WeekGridComponent) private grid?: WeekGridComponent;

  private _popupVisible: boolean = false;
  private savedValue: WeekCalendar | null | undefined;
  // A new reference on every reset, so the grid re-reads it even when the saved value didn't change
  protected draft: WeekCalendar = { timezone: this.timezone, days: [] };

  constructor(protected appService: AppService) {}

  // Toolbar buttons are declared as widget="dxButton" so DevExtreme re-creates them when the toolbar re-renders
  protected onSaveClick = () => this.save();
  protected onCancelClick = () => this.cancel();

  protected save() {
    if (!this.editMode || !this.grid) return;
    this.valueChange.emit({ timezone: this.timezone, days: this.grid.toDays() });
    this.popupVisible = false;
  }

  protected cancel() {
    this.popupVisible = false;
  }

  private resetDraft() {
    if (this.savedValue?.timezone) this.timezone = this.savedValue.timezone;
    this.draft = this.savedValue ? { ...this.savedValue } : { timezone: this.timezone, days: [] };
  }
}
